/**
 * SUN-285: the opening rate of a purchase line. ONE rule for the PO editor and Quick PO:
 * last purchase / contract rate first, else the product's COST price. Never the selling price.
 * A cost of 0 is the "not known" default, so it is not offered (the buyer types the rate).
 */
export function defaultLineRate(o: { lastRate?: number | null; costPrice?: number | null }): number {
  if (o.lastRate != null && Number.isFinite(o.lastRate)) return o.lastRate;
  const cost = Number(o.costPrice);
  return Number.isFinite(cost) && cost > 0 ? cost : 0;
}
